module.exports = __webpack_public_path__ + "img/logo_lanin-turismo-aventura.175ef256.png";